import { ProductsService } from "./../../../Services/product.service";
import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EmbryoService } from "../../../Services/Embryo.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginUsersService } from "src/app/Services/login-users.service";
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper/core/";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { DomSanitizer } from "@angular/platform-browser";
import { MetaService } from "src/app/Services/meta-data.service";
import { Subscription } from "rxjs";
import { interval ,fromEvent} from "rxjs";
import { filter, map, merge } from "rxjs/operators";
SwiperCore.use([Pagination, Navigation, Autoplay]);

@Component({
    selector: "app-DetailPage",
    templateUrl: "./DetailPage.component.html",
    styleUrls: ["./DetailPage.component.scss"],
})
export class DetailPageComponent implements OnInit, OnDestroy {
    @ViewChild("relatedSwiper", { static: false }) relatedSwiper: any;
    @ViewChild("productSwiper", { static: false }) productSwiper: any;
    bigSwiperConfig: any = {};
    id: any;
    type: any;
    apiResponse: any;
    singleProductData: any;
    productsList: any;
    relatedProducts = [];
    dataProduct: any;
    dataProductSimilarProducts = [];
    productListLocal: any;
    lang: string = "";
    direction: string = "ltr";
    environmentVariables: any;
    loading = false;
    areaSubscription: Subscription;
    branchSubscription: Subscription;
    isAvalableSlug = 1;
    public variantfound: any;
    showNotAvaliableSection = false;
    installment: any;

    constructor(
        private route: ActivatedRoute,
        private productsService: ProductsService,
        private translate: TranslateService,
        public embryoService: EmbryoService,
        private auth: LoginUsersService,
        private router: Router,
        private confgServ: StaticPagesService,
        private sanitizer: DomSanitizer,
        private metaService: MetaService
    ) {
        this.areaSubscription = this.auth.getAreaDataEmit().subscribe((res) => {
            this.getData();
        });
        
       this.branchSubscription = this.auth
        .getBranchDataEmit()
        .subscribe((res) => {
              this.getData();
            });

        this.getInitilizingData();
        if (
            this.environmentVariables &&
            this.environmentVariables?.PRODUCT_CARD_STYLE != "large"
        ) {
            this.bigSwiperConfig = {
                slidesPerView: 6,
                draggable: true,
                breakpoints: {
                    1440: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween: 10,
                    },
                    900: {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                    },
                    500: {
                        slidesPerView: this.environmentVariables
                            ?.SHOW_SECTIONS_AS_SLIDER
                            ? 2
                            : 1,
                        spaceBetween: 10,
                    },
                    0: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                centeredSlides: false,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop: this.environmentVariables?.ENABLE_SIMILAR_PRODUCTS_LOOP
                    ? true
                    : false,
                responisve: true,
                initialSlide: 0,
            };
        } else {
            this.bigSwiperConfig = {
                slidesPerView: 4,
                draggable: true,
                breakpoints: {
                    1500: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    1280: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    770: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    450: {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                    },
                    100: {
                        slidesPerView: 1,
                    },
                },
                spaceBetween: 10,
                navigation: true,
                pagination: false,
                centeredSlides: true,
                centeredSlidesBounds: true,
                autoplay: {
                    delay: 2500,
                    pauseOnMouseEnter: true,
                },
                loop:
                    this.environmentVariables &&
                    this.environmentVariables?.ENABLE_SIMILAR_PRODUCTS_LOOP
                        ? true
                        : false,
                responisve: true,
            };
        }
    }

    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang") || "";
        this.translate.setDefaultLang(this.lang);
        this.route.params.subscribe((param) => {
            this.dataProduct = null;
              this.id = param["name"];
                     const interval$ = interval(1000);
                 const storage$ = fromEvent<StorageEvent>(window, 'storage').pipe(
                      filter((event) => event.key === 'auth_token'),
                      map((event) => event.newValue)
                    );
                const subscription = interval$.pipe(
                  filter(() => localStorage.getItem('auth_token') !== null),
                  merge(storage$)
                ).subscribe(() => {
                  subscription.unsubscribe();
                  this.getData();
                });

        });
        this.embryoService.emitLang.subscribe((lang: string) => {
            this.translate.setDefaultLang(lang);
            if (this.lang !== lang) {
                this.getData();
                this.direction = "ltr";
            } else {
                this.direction = "rtl";
            }
            this.lang = lang;
        });
    }

    getData(id = this.id) {
        this.route.queryParams.subscribe((params) => {
             this.variantfound  = Number(params["variant"]);
           })
           console.log('this.variantfound ==>', this.variantfound)
           if(!this.variantfound){
            if (id) {
            this.loading = true;
            this.productsService.getProductBySlug(id).subscribe({
                next: (rep: any) => {
                    if (rep.code === 200) {
                        this.dataProduct = rep.data.product;
                        if (this.environmentVariables.ENABLE_BANK_INSTALLMENTS_PRODUCT_UI) {
                            this.productsService.getBankInstallmentsByPrice(this.dataProduct.price)
                                .subscribe((response: any) => {
                                    this.installment = response.data;
                                })
                        }
                        rep.data.product.description =
                            this.sanitizer.bypassSecurityTrustHtml(
                                rep.data.product.description
                            );
                        rep.data.product.description_ar =
                            this.sanitizer.bypassSecurityTrustHtml(
                                rep.data.product.description_ar
                            );
                        rep.data.product.description_en =
                            this.sanitizer.bypassSecurityTrustHtml(
                                rep.data.product.description_en
                            );
                        this.dataProduct ? this.showNotAvaliableSection = true : this.showNotAvaliableSection = false;
                    
                        this.productsList = rep.data.similar_products;
                        this.relatedProducts = rep.data.product.related_skus;


                           let link  : any = document.querySelector(
                              "link[rel='canonical']"
                            );
                            link.setAttribute('href', `${window.location.href}`);

                        this.metaService.updateTag({
                            property: "og:title",
                            content:
                                this.lang == "en"
                                    ? rep.data.product.name_en
                                    : rep.data.product.name_ar,
                        });
                        this.metaService.updateTag({
                            property: "og:description",
                            content:
                                this.lang == "en"
                                    ? rep.data.product.description_en
                                    : rep.data.product.description_ar,
                        });
                        this.metaService.updateTag({
                            property: "og:image",
                            content:
                                rep?.data?.product?.images[0]?.url ||
                                rep.data.product.image,
                        });
                        this.metaService.updateTag({
                            property: "og:image:url",
                            content:
                                rep?.data?.product?.images[0]?.url ||
                                rep.data.product.image,
                        });
                    } else if (rep.code === 404 || rep.code === 400) {
                        this.router.navigate(["/" + this.lang + "/not-found"]);
                    }
                    this.loading = false;
                },
            });
           } else {
            this.getData();
          }
          }else{
            this.loading = true;
            this.productsService.getComparedProductById(this.variantfound).subscribe(res=>{
              console.log(res);
            this.loading = false;
              
              if(res.code == 200){
                this.router.navigate([`${this.lang}/${res.data.product.slug}`])
              }
            })
                
            
          }
    }

    addToCart(value: any) {
        this.embryoService.addToCartGuest(value);
    }

    addToWishList(value: any) {
        this.embryoService.addToWishlist(value);
    }
    ngOnDestroy() {
        this.areaSubscription.unsubscribe();
        this.branchSubscription.unsubscribe();
    }
}
